module.exports = __webpack_public_path__ + "img/ms.70dbb3e.svg";